<template>


    <div >
        <v-col cols="3" class="d-flex justify-begin mb-2">
      <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
              
              </v-col>
        <div class="contenedor-tabla">
          <div class="scroll-container"
          >
          <table
          
          
          >
              <!-- <caption class="table-header">Senda de {{ this.$t('tabs.electricidad_precios_manual') }}</caption> -->
              <thead>
              <tr>
                  <th class="encabezado_bold" >{{ this.$t('electricidad.horizonte') }}</th>
                  <th class="encabezado_bold" >{{ this.$t('electricidad.hora') }}</th>
                  <th class="encabezado_bold" >{{ this.$t('electricidad.precio_mercado') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="( row,index) in precioMercado.slice(0,this.horizonte_horas)" :key="index" class="tabla-hover">
                  <td class="primera_columna">{{row.horizonte}}</td>
                  <td class="primera_columna "  style="text-align: center !important;">{{row.hora }}</td>
                  <td>
                      <input
                  type="number"
                  v-model.number="row.valor"
                  @input="emitChanges(index)"
          
                />
                  </td>
              </tr>
              </tbody>
          </table>
          </div>
        </div>
        <v-dialog v-model="showAlert" max-width="400">
                   <v-card>
                     <v-card-title class="headline">{{$t('simulaciones.advertencia')}}</v-card-title>
                     <v-card-text>
                       {{ error_msg }}
                     </v-card-text>
                     <v-card-actions>
                       <v-spacer></v-spacer>
                       <v-btn color="primary" text @click="showAlert = false">{{$t('simulaciones.cerrar')}}</v-btn>
                     </v-card-actions>
                   </v-card>
                 </v-dialog>
    </div>
  
               

</template>

<script>

import Papa from 'papaparse';
import Swal from 'sweetalert2';

const HEADERS_OFICIALES_ELEC_MANUAL = [
  "Horizonte",
  "Hora",
  "Precio mercado (€/MWh)"
];
//imports
export default{
   props:{
      elec_manual:{
          type:Array,
          required:true,
      },
      horizonte:{
        type:Number,
        required:true,
      },
    fecha:{
      type:String,
      required:true,
    },
    horizonte_horas:{
      type:Number,
      required:true,
    }
   },
   computed:{
    precioMercado(){
      return [...this.elec_manual];
    }
   },

   data(){
       return{
            error_msg:"",
            showAlert:false,
            matrixData : [
                   
               ],
           
           //precioMercado : [...this.elec_manual],
                   hoursList:[],
               columns:[
               { name: "Horizonte", prop: "horizonte", size: 150, readonly:true },
               { name: "Hora", prop: "hora", size: 150, readonly:true },
               {name: "Precio mercado (€/MWh)", prop:"valor",size:200},
               
                   ],
       }
   },
   created(){
       //this.crearColumnas(7);
   },
   watch: {
    precioMercado: {
        handler() {
            const newArray = [...this.precioMercado];
            this.$emit('update:elec_manual', newArray);
        },
        deep:true,
     },
    /* elec_manual:{
      handler(){
        this.precioMercado =[...this.elec_manual];
        this.crearColumnas(7);
        
      },
      deep:true,
    }, */
   },

   methods:{
    toCsvDecimalComma(v, fixed = 2) {
    if (v === null || v === undefined || v === '') return '';
    let n = Number(v);
    if (Number.isNaN(n)) n = Number(String(v).replace(',', '.')); 
    if (Number.isNaN(n)) return '';
    return n.toLocaleString('es-ES', {
      minimumFractionDigits: fixed,
      maximumFractionDigits: fixed,
      useGrouping: false, 
    });
  },
    //Exportar archivos a CSV
    exportToCSV() {
    const headers = this.columns.map((col) => col.name).join(";");

    const rows = (this.precioMercado || [])
      .slice(0, this.horizonte_horas)
      .map((row) =>
        this.columns.map((col) => {
          const val = row[col.prop];
          if (val === undefined || val === null) return "";
          return col.prop === "valor" ? this.toCsvDecimalComma(val, 2) : String(val);
        }).join(";")
      );

    const csvContent = [headers, ...rows].join("\n");
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "precios_elec_manuales.csv";
    a.click();
    URL.revokeObjectURL(url);
  },
    parseNumber(value) {
            if (!value) return 0;
            value = value.trim();

            if (value.includes(',') && !value.includes('.')) {
                value = value.replace(/\./g, '');        
                value = value.replace(',', '.');          
            }

            else if (value.includes(',') && value.includes('.')) {
                
                if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
                value = value.replace(/\./g, '');       
                value = value.replace(',', '.');      
                }
                
                else {
                value = value.replace(/,/g, '');        
                }
            }
            return parseFloat(value);
            },

    convertirFecha(fechaString) {
          let [fecha,hora]=fechaString.split(' ');
          //Por problemas de leer de csv, a veces la fecha
          let dia;
          let mes;
          let anio;
          if (fecha.includes('/')) {
            // Si la fecha tiene '/' como separador
             [dia, mes, anio] = fecha.split('/');
            } else if (fecha.includes('-')) {
                // Si la fecha tiene '-' como separador
             [anio, mes, dia] = fecha.split('-');
            }
          let [horaStr,minutoStr] = hora.split(':')
          horaStr = horaStr.padStart(2,'0');
          //console.log("Fecha: ", `${anio}-${mes}-${dia} ${horaStr}:${minutoStr}`)
          horaStr = horaStr.padStart(2,'0'); //Rellenar los dígitos individuales en 2
          const fechaItem = `${anio}-${mes}-${dia} ${horaStr}:${minutoStr}`
          return fechaItem;
        },
    //Llamada a input de CSV
    importFromCSV() {
      this.$refs.fileInput.click();
    },

    //Gestión de subida de archivos CSV
   handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = e.target.result;

      Papa.parse(data, {
        delimiter: ';',
        skipEmptyLines: true,
        header: true, // el CSV DEBE tener cabeceras
        complete: (result) => {
          const rowsRaw = result.data || [];
          // quita filas totalmente vacías
          const rows = rowsRaw.filter(r => Object.values(r).some(v => String(v ?? '').trim() !== ''));
          if (!rows.length) throw new Error('El CSV está vacío.');

          // ========= Validación de CABECERAS =========
          let columnas = Object.keys(rows[0] || {}).map((h, i) =>
            (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim()
          );
          // 1) faltantes / extras
          const faltantes = HEADERS_OFICIALES_ELEC_MANUAL.filter(h => !columnas.includes(h));
          const extrasRaw = columnas.filter(h => !HEADERS_OFICIALES_ELEC_MANUAL.includes(h));

          // limpiar valores vacíos/espacios 
          const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);

          // 2) desordenadas solo si no hay faltantes ni extras visibles
          let desordenadas = [];
          
          HEADERS_OFICIALES_ELEC_MANUAL.forEach((h, i) => {
            if (columnas[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
          });

          if (faltantes.length || extras.length || desordenadas.length) {
            const seccion = (titulo, arr) =>
              arr.length
                ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4><ul style="margin:0 0 8px 18px; padding:0;">${arr.map(x => `<li>${x}</li>`).join('')}</ul>`
                : '';

            const html =
              `<div style="text-align:left;">
                 <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
                 ${seccion('❌ Faltan', faltantes)}
                 ${seccion('⚠️ Sobran', extras)}
                 ${seccion('🔄 Desordenadas', desordenadas)}
               </div>`;

            Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html });
            event.target.value = '';
            return; // 
          }
          // ========= Fin validación de CABECERAS =========
          /* mismo nº de filas que horizonte_horas
          if (rows.length !== this.horizonte_horas) {
            throw new Error(`Se esperaban ${this.horizonte_horas} filas y se recibieron ${rows.length}.`);
          }*/
          //  bloquear si falta Horizonte u Hora o Precio en alguna fila
          const faltasPorCol = { 'Horizonte': [], 'Hora': [], 'Precio mercado (€/MWh)': [] };

          rows.forEach((r, idx) => {
            const line = idx + 2; // 1 cabecera + base1
            const h = String(r['Horizonte'] ?? '').trim();
            const hora = String(r['Hora'] ?? '').trim();
            const precioRaw = r['Precio mercado (€/MWh)'];

            if (!h) faltasPorCol['Horizonte'].push(line);
            if (!hora) faltasPorCol['Hora'].push(line);

            if (precioRaw === undefined || precioRaw === null || String(precioRaw).trim() === '') {
              faltasPorCol['Precio mercado (€/MWh)'].push(line);
            } else {
              const n = this.parseNumber(precioRaw);
              // se permiten negativos; solo validamos que sea numérico
              if (!Number.isFinite(n)) faltasPorCol['Precio mercado (€/MWh)'].push(line);
            }
          });

          const columnasConFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length > 0);

            if (columnasConFaltas.length) {
              const html =
                `<div style="text-align:left;">
                  ${columnasConFaltas.map(([col, arr]) =>
                    `• <b>${col}</b>: líneas <b>${arr.join(', ')}</b>`
                  ).join('<br>')}
                </div>`;
              Swal.fire({ icon: 'error', title: 'Faltan datos obligatorios', html });
              event.target.value = '';
              return; // bloquear importación
            }

          // Mapear por 'Horizonte' y actualizar 'valor' (se admiten negativos)
          const missing = [];
          rows.forEach((row) => {
            const horizonteCsv = this.convertirFecha(String(row['Horizonte']).trim());
            const precioCsv = this.parseNumber(row['Precio mercado (€/MWh)']);

            if (!Number.isFinite(precioCsv)) {
              throw new Error(`Valor no numérico en 'Precio mercado (€/MWh)' para horizonte ${row['Horizonte']}.`);
            }

            const existente = this.precioMercado.find(it => it.horizonte === horizonteCsv);
            if (existente) {
              existente.valor = precioCsv; // interno con punto (negativos permitidos)
            } else {
              missing.push(row['Horizonte']);
            }
          });

          if (missing.length) {
            throw new Error(`Horizontes no encontrados en la senda: ${missing.slice(0,5).join(', ')}${missing.length>5?'…':''}`);
          }

          // Emitir cambios
          this.emitChanges();
          Swal.fire({ icon: 'success', title: 'Importación correcta', text: `${rows.length} registros actualizados.` });
        },
        error: () => {
          throw new Error('No se pudo leer el CSV.');
        }
      });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = ''; // reset input
    }
  };

  reader.readAsText(file, 'utf-8');
},

    emitChanges(){
        //console.log("cambiosn: ");
        //console.log(this.matrixData[index].precioMercado);

        //const valores=this.precioMercado;
        this.$emit("update:elec_manual", this.precioMercado);
    },
       crearColumnas(dias){
            //const currentDate = new Date();

            const [dia, mes, anio] = this.fecha.split("/").map(Number);
            let currentDate = new Date(anio, mes - 1, dia);

            // Sumar un día a la fecha actual
            currentDate.setDate(currentDate.getDate() + 1);
            

            // Generar la columna con las horas
             this.hoursList = [];
             this.matrixData=[];
            for (let day=0; day<dias;day++){
                const newDate = new Date(currentDate);
                newDate.setDate(currentDate.getDate() + day);
                const formattedDate = newDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // Formato 28-01-25
        
                for (let i = 0; i < 24; i++) {
                    const hour = i.toString().padStart(2, '0'); // Asegura que la hora tenga 2 dígitos
                    this.hoursList.push(`${formattedDate} ${hour}:00`);
                    this.matrixData.push({
                        horizonte:`${formattedDate} ${hour}:00`,
                        
                        precioMercado: this.precioMercado[i+(24*day)],
                    })
                }
            }
            //console.log(hoursList);
       },
       error(n_error,aux=""){
        switch(n_error){
            case 1:
                this.error_msg="El csv debe contener las cabeceras de 'Horizonte' y 'Precio mercado (€/MWh)'";
              break;
            case 2:
              this.error_msg="El horizonte del csv no coindide con el de la senda." + aux;
            break;
        }
        this.showAlert=true
       }

   },
}

</script>
<style scoped>
.contenedor-tabla {
  max-width: 600px;
 /*  margin: auto; */
}
.scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
   border-radius: 10px;
  display: flex;
  flex-direction: column;
}
table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
  thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }
  .table-header {
    position: sticky;
    top: 0;
    z-index: 15;
    background-color: #006699;
    color: white;
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    padding: 10px;
  }

  
/*   th {
    border: 2px solid #D9D9D9;
    background-color: white;
    color: #024e74;
    padding: 10px;
    font-weight: bold;
    font-size: large;
    min-width: 150px;
    
  } */
  .primera_columna{
    background-color: white;
  }
  .valor_fijo{
    background-color: white;
  }
/*   td {
    font-weight: bold;
    color: #024e74;
    border: 2px solid #D9D9D9;
    padding: 10px;
    background-color: #F2F2F2;
  } */
  input[type="number"] {
    width: 100%;
    text-align: center;
    border: none;
    border-radius: 4px;
    color: #024e74;
  }
  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
  
  input[disabled] {
    background-color: white;
    color: #024e74;
    cursor: not-allowed;
  }
  .encabezado_bold{
  font-size: 14px;
}
</style>

